const examples = [
  {
    title: 'Обучение отдела продаж',
    costs: '10 000 BYN (тренинг для 12 менеджеров)',
    result: 'Конверсия выросла с 14% до 21%, средний чек — на 18%. Дополнительная выручка за 6 месяцев: 62 000 BYN.',
    roi: '520%',
    roiText: 'Каждый вложенный рубль принёс 5,2 рубля прибыли',
  },
  {
    title: 'Внедрение наставничества',
    costs: '8 000 BYN (подготовка 6 наставников + чек-листы)',
    result: 'Адаптация новичков сократилась с 4 до 1,5 месяцев. Текучесть в первый год снизилась на 35%. Экономия на подборе: 36 000 BYN.',
    roi: '450%',
    roiText: 'Каждый вложенный рубль принёс 4,5 рубля экономии',
  },
  {
    title: 'Тренинг для руководителей',
    costs: '15 000 BYN (программа для 8 руководителей, 3 месяца)',
    result: 'Производительность отделов выросла на 18%. Снижение конфликтов — на 40%. Выполнение KPI подчинёнными — рост с 62% до 84%. Дополнительный результат: 54 000 BYN.',
    roi: '360%',
    roiText: 'Каждый вложенный рубль принёс 3,6 рубля дополнительного результата',
  },
];

export default function TrainingROI() {
  return (
    <section id="roi" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          ROI корпоративного обучения — когда цифры убедительнее слов
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          ROI обучения = (Финансовый результат - Затраты на обучение) / Затраты на обучение × 100%. Грамотно выстроенное корпоративное обучение окупается многократно.
        </p>

        <div className="max-w-3xl mx-auto mb-12">
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Как считать ROI обучения</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white font-bold text-sm">1</span>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Замерьте KPI до обучения</div>
                  <div className="text-gray-600 text-sm">Зафиксируйте базовые показатели: конверсию, средний чек, длину сделки, текучесть</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white font-bold text-sm">2</span>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Проведите обучение с внедрением</div>
                  <div className="text-gray-600 text-sm">Не просто тренинг, а программа: обучение + практика + домашние задания + сопровождение</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white font-bold text-sm">3</span>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Повторно замерьте KPI через 2-3 месяца</div>
                  <div className="text-gray-600 text-sm">Сравните показатели с базовыми. Разница в деньгах — это эффект от обучения</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white font-bold text-sm">4</span>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Рассчитайте ROI</div>
                  <div className="text-gray-600 text-sm">ROI = (Эффект - Затраты) / Затраты × 100%. Например: (50 000 - 10 000) / 10 000 × 100% = 400%</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {examples.map((e, i) => (
            <div key={i} className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-md transition-all">
              <div className="bg-teal-600 px-6 py-4">
                <h3 className="text-lg font-bold text-white">{e.title}</h3>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <div className="text-xs text-gray-500 mb-1">Затраты</div>
                  <div className="text-sm text-gray-700 font-medium">{e.costs}</div>
                </div>
                <div className="mb-4">
                  <div className="text-xs text-gray-500 mb-1">Результат</div>
                  <div className="text-sm text-gray-700">{e.result}</div>
                </div>
                <div className="bg-teal-50 rounded-xl p-4 text-center">
                  <div className="text-3xl font-extrabold text-teal-700">{e.roi}</div>
                  <div className="text-xs text-teal-600 mt-1">{e.roiText}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}